import React from 'react';
import Subtitle from 'Components/ComponentLibrary/Atoms/Text/Subtitle';
import PropTypes from 'prop-types';


const WizardSubtitleText = ({
  value,
  subtitleTest,
  textAlign,
}) => {
  if (Array.isArray(value)) {
    return value.map(text => (<Subtitle align={textAlign} key={text} value={text} test={subtitleTest} />));
  }
  return <Subtitle align={textAlign} value={value} test={subtitleTest} />;
};

WizardSubtitleText.defaultProps = {
  subtitleTest: 'wizard-step-subtitle',
  textAlign: 'center',
};

WizardSubtitleText.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]).isRequired,
  textAlign: PropTypes.oneOf(['left', 'center']),
  subtitleTest: PropTypes.string,
};

export default WizardSubtitleText;
